import axios from './../axios';
import util from './util';
const apiPath = 'api/admin/members';

const memberApi = {
    index: query => {
        return axios.get(
            `${
                process.env.VUE_APP_API_ENDPOINT
            }/${apiPath}/index?${util.queryToString(query)}`
        );
    },
    show: id => {
        return axios.get(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/show/${id}`
        );
    },
    update: (id, entity) => {
        return axios.put(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/update/${id}`,
            {
                ...entity
            }
        );
    },
    banAgent: (id, entity) => {
        return axios.put(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/ban-agent/${id}`,
            {
                ...entity
            }
        );
    },
    unbanAgent: (id, entity) => {
        return axios.put(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/unban-agent/${id}`,
            {
                ...entity
            }
        );
    },
    banForum: (id, entity) => {
        return axios.put(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/ban-forum/${id}`,
            {
                ...entity
            }
        );
    },
    unbanForum: (id, entity) => {
        return axios.put(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/unban-forum/${id}`,
            {
                ...entity
            }
        );
    },
    forceResetPassword: (id, entity) => {
        return axios.post(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/${id}/force_reset_password`,
            {
                ...entity
            }
        );
    },
    addMembership: entity => {
        return axios.put(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/add-membership`,
            {
                ...entity
            }
        );
    },
    expireMembership: entity => {
        return axios.put(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/expire-membership`,
            {
                ...entity
            }
        );
    },
    getWalletHistory: (id, query = {}) => {
        return axios.get(
            `${
                process.env.VUE_APP_API_ENDPOINT
            }/${apiPath}/${id}/wallet-history?${util.queryToString(query)}`
        );
    }
};

export default memberApi;
